// What the "Extend" action on a My Access row should do. Resources that mandate
// a reason (`requiresComment`) can't be one-click extended — the user is sent to
// the dedicated extension screen where the reason is collected (the same screen
// the chat "Review & extend" links open). Everything else extends in place via
// the decide mutation.
//
// Kept as a pure helper so the branch is unit-testable without a DOM (mirrors
// components/RequestAccess/commentRequirement.ts). The row's inline handler
// previously read an undefined `sr`, throwing "ReferenceError: sr is not
// defined" on every Extend click (PLO-4463); routing the decision through this
// helper keeps the resource lookup in one typed, tested place.

import type { MFSelectableResourceAccess } from "state/members/access_v2/catalogs";

export type ExtendAction =
  | { kind: "navigate"; path: string }
  | { kind: "decide" };

export const extendAction = (
  access: MFSelectableResourceAccess,
): ExtendAction =>
  access.selectableResource?.requiresComment
    ? { kind: "navigate", path: `/members/extensions/${access.id}` }
    : { kind: "decide" };
